import React, {useState} from 'react';
import './Navbar.scss';
import logo from '../../Assets/Images/Logo.svg'
import {NavLink} from 'react-router-dom';
import {Button, Menu, MenuItem} from "@mui/material";
import media1 from "../../Assets/Images/facebook-3-512.png";
import media5 from "../../Assets/Images/instagram.png";
import media4 from "../../Assets/Images/youtube.png";
import media2 from "../../Assets/Images/linkedin-3-512.png";
import media3 from "../../Assets/Images/yelp.png";
import useMatchMedia from "react-use-match-media";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import Breadcrumbs from "../../breadcrumbs";

export default function Navbar() {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [anchorEl1, setAnchorEl1] = React.useState(null);
    const open = Boolean(anchorEl);
    const open1 = Boolean(anchorEl1);
    const handleNav = () => {
        setActive(!active);
    }
    const handleClickk = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClickk1 = (event) => {
        setAnchorEl1(event.currentTarget);
    };

    const [active, setActive] = useState(false);

    const handleClick = () => {
        setActive(!active);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setAnchorEl1(null);
    };
    // useEffect(() => {
    //     if (active) {
    //         document.body.style.overflow = "hidden";
    //     } else {
    //         document.body.style.overflow = "auto";
    //     }
    // }, [active])
    const [colorChange, setColorchange] = useState(false);
    const changeNavbarColor = () => {
        if (window.scrollY >= 80) {
            setColorchange(true);
        } else {
            setColorchange(false);
        }
    };
    window.addEventListener('scroll', changeNavbarColor);
    const isDesktopResolution = useMatchMedia('(min-width:1200px)', true)
    return (
        <nav className={colorChange ? 'nav colorChange ' : 'nav'}>
            <div className="logo_nav">
                <NavLink to='/' exact>
                    <img
                        src={logo}
                        alt="logo"
                    />
                </NavLink>
            </div>
            <div className={`menu-icon ${active ? 'open' : ""}`} id="nav-icon1" onClick={handleClick}>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div className={active ? `${"nav_link"} ${"active1"}` : "nav_link"}>
                <div className="mob_links">
                    <NavLink
                        to='/'
                        exact
                        className={"link"}
                        activeClassName={"active"}
                        onClick={handleNav}
                    >
                        Home
                    </NavLink>
                    {!isDesktopResolution ?
                        <>
                        <Button
                            id="demo-customized-button"
                            aria-controls={open ? 'demo-customized-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                            disableElevation
                            onClick={handleClickk}
                            className="link"
                            style={{justifyContent:"flex-start",order:3}}
                            endIcon={<KeyboardArrowDownIcon/>}
                        >
                           Services
                        </Button>
                        <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            MenuListProps={{
                                'aria-labelledby': 'basic-button',
                            }}
                            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                            transformOrigin={{vertical: 'bottom', horizontal: 'center'}}
                            PaperProps={{
                                style: {
                                    transform: 'translateX(0) translateY(20%)',
                                }
                            }}
                            endIcon={<KeyboardArrowDownIcon/>}
                        >

                            <MenuItem onClick={handleClose} className="menu">
                                <NavLink
                                    to='/auto-body-repair'
                                    exact
                                    style={{color: "#0A1315"}}
                                    // className="link firstLink"
                                    activeClassName="active"
                                    onClick={handleNav}
                                >
                                    Auto Body Repair
                                </NavLink>
                            </MenuItem>
                            <MenuItem onClick={handleClose} className="menu">
                                <NavLink
                                    to='/car-painting'
                                    exact
                                    style={{color: "#0A1315"}}
                                    // className="link firstLink"
                                    activeClassName="active"
                                    onClick={handleNav}
                                >
                                   Auto Body Paint
                                </NavLink>
                            </MenuItem>
                            <MenuItem onClick={handleClose} className="menu">
                                <NavLink
                                    to='/fiberglass-repair'
                                    exact
                                    style={{color: "#0A1315"}}
                                    // className="link firstLink"
                                    activeClassName="active"
                                    onClick={handleNav}
                                >
                                    Fiberglass Repair
                                </NavLink>
                            </MenuItem>
                            <MenuItem onClick={handleClose} className="menu">
                                <NavLink
                                    to='/car-mechanic'
                                    exact
                                    style={{color: "#0A1315"}}
                                    // className="link firstLink"
                                    activeClassName="active"
                                    onClick={handleNav}
                                >
                                    Vehicle Diagnostics & Mechanical Work
                                </NavLink>
                            </MenuItem>
                            <MenuItem onClick={handleClose} className="menu">
                                <NavLink
                                    to='/vehicle-frame-repair'
                                    exact
                                    style={{color: "#0A1315"}}
                                    // className="link firstLink"
                                    activeClassName="active"
                                    onClick={handleNav}
                                >
                                    Frame Straightening
                                </NavLink>
                            </MenuItem>
                            <MenuItem onClick={handleClose} className="menu">
                                <NavLink
                                    to='/services'
                                    exact
                                    style={{color: "#0A1315"}}
                                    // className="link firstLink"
                                    activeClassName="active"
                                    onClick={handleNav}
                                >
                                   Including Services
                                </NavLink>
                            </MenuItem>
                        </Menu>
                        </>
                        :
                        <>
                        <NavLink
                            className="link dropdown"
                            to='/services'
                            exact
                        >
                            <a className="dropbtn">Services</a>
                            <div className="dropdown-content">
                                <NavLink
                                    to='/auto-body-repair'
                                    exact
                                    // className="link firstLink"
                                    activeClassName="active"
                                    onClick={handleNav}
                                >
                                    Auto Body Repair
                                </NavLink>
                                <NavLink
                                    to='/car-painting'
                                    exact
                                    // className="link"
                                    activeClassName="active"
                                    onClick={handleNav}
                                >
                                    Auto Body Paint
                                </NavLink>

                                <NavLink
                                    to='/fiberglass-repair'
                                    exact
                                    // className="link"
                                    activeClassName="active"
                                    onClick={handleNav}
                                    style={{textTransform:'uppercase'}}
                                >
                                    Fiberglass Repair
                                </NavLink>
                                <NavLink
                                    to='/car-mechanic'
                                    exact
                                    // className="link"
                                    activeClassName="active"
                                    onClick={handleNav}
                                    style={{textTransform:'uppercase'}}

                                >
                                    Vehicle Diagnostics & Mechanical Work
                                </NavLink>
                                <NavLink
                                    to='/vehicle-frame-repair'
                                    exact
                                    // className="link"
                                    activeClassName="active"
                                    onClick={handleNav}
                                    style={{textTransform:'uppercase'}}

                                >
                                    Frame Straightening
                                </NavLink>
                                <NavLink
                                    to='/services'
                                    exact
                                    // className="link"
                                    activeClassName="active"
                                    onClick={handleNav}
                                    style={{textTransform:'uppercase'}}

                                >
                                    Including Services
                                </NavLink>
                            </div>
                        </NavLink>
                        </>
                        }
                <NavLink
                    to='/gallery'
                    exact
                    className={"link"}
                    activeClassName={"active"}
                    onClick={handleNav}
                >
                    Gallery
                </NavLink>
                <NavLink
                    to='/partners'
                    exact
                    className={"link"}
                    activeClassName={"active"}
                    onClick={handleNav}
                >
                    PARTNERS
                </NavLink>
                    {!isDesktopResolution ?
                        <>
                        <Button
                            id="demo-customized-button"
                            aria-controls={open1 ? 'demo-customized-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open1 ? 'true' : undefined}
                            disableElevation
                            onClick={handleClickk1}
                            className="link"
                            style={{justifyContent:"flex-start",order:3}}
                            endIcon={<KeyboardArrowDownIcon/>}
                        >
                            Certificates
                        </Button>
                        <Menu
                            id="basic-menu"
                            anchorEl={anchorEl1}
                            open={open1}
                            onClose={handleClose}
                            MenuListProps={{
                                'aria-labelledby': 'basic-button',
                            }}
                            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                            transformOrigin={{vertical: 'bottom', horizontal: 'center'}}
                            PaperProps={{
                                style: {
                                    transform: 'translateX(0) translateY(20%)',
                                }
                            }}
                            endIcon={<KeyboardArrowDownIcon/>}
                        >

                            <MenuItem onClick={handleClose} className="menu">
                                <NavLink
                                    to='/certificates/mercedes-collision-center'
                                    exact
                                    style={{color: "#0A1315"}}
                                    // className="link firstLink"
                                    activeClassName="active"
                                    onClick={handleNav}
                                >
                                    Mercedes Benz Collision Center
                                </NavLink>
                            </MenuItem>
                            <MenuItem onClick={handleClose} className="menu">
                                <NavLink
                                    to='/certificates'
                                    exact
                                    style={{color: "#0A1315"}}
                                    // className="link firstLink"
                                    activeClassName="active"
                                    onClick={handleNav}
                                >
                                    Certificates
                                </NavLink>
                            </MenuItem>
                        </Menu>
                        </>
                        :
                <NavLink
                    to='/certificates'
                    exact
                    className={"link dropdown"}
                    activeClassName={"active"}
                    onClick={handleNav}
                >
                    <a className="dropbtn">CERTIFICATES</a>
                    <div className="dropdown-content">
                        <NavLink
                            to='/certificates/mercedes-collision-center'
                            exact
                            // className="link firstLink"
                            activeClassName="active"
                            onClick={handleNav}
                        >
                            Mercedes Benz Collision Center
                        </NavLink>
                        <NavLink
                            to='/certificates'
                            exact
                            // className="link"
                            activeClassName="active"
                            onClick={handleNav}
                            style={{textTransform:'uppercase'}}

                        >
                            Certificates
                        </NavLink>
                    </div>

                </NavLink>
                        }
                <NavLink
                    to='/careers'
                    exact
                    className={"link"}
                    activeClassName={"active"}
                    onClick={handleNav}
                >
                    CAREERS
                </NavLink>
                <NavLink
                    to='/blog'
                    exact
                    className={"link"}
                    activeClassName={"active"}
                    onClick={handleNav}
                >
                    BLOG
                </NavLink>
                <NavLink
                    to='/about'
                    exact
                    className={"link"}
                    activeClassName={"active"}
                    onClick={handleNav}
                >
                    ABOUT US
                </NavLink>
            </div>
                <ul className={"media"}>
                    <li>
                        <a href="https://www.facebook.com/lawestcollision" target="_blank"> <img src={media1} alt=""/></a>
                    </li>
                    <li>
                        <a href="https://www.instagram.com/lawestcollision/" target="_blank"> <img src={media5} alt=""/></a>
                    </li>
                    <li>
                        <a href="https://www.youtube.com/channel/UCE_wG3hHmcVrLLhitI0V0iQ" target="_blank"> <img src={media4} alt=""/></a>
                    </li>
                    <li>
                        <a href="https://www.linkedin.com/company/lawest/" target="_blank"> <img src={media2}  alt=""/></a>
                    </li>

                    <li>
                        <a href="https://s.yelp.com/IZ7jKEeM6z" target="_blank"> <img src={media3} alt=""/></a>
                    </li>
                </ul>
                <div className={"content"}>
                    <ul>
                        <li>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.0639 16.9998C9.60049 16.9953 6.28026 15.6148 3.83128 13.161C1.3823 10.7071 0.00448915 7.38029 0 3.91004C0 2.87306 0.411123 1.87855 1.14293 1.14529C1.87473 0.412036 2.86727 9.71492e-05 3.90219 9.71492e-05C4.12135 -0.00157546 4.34013 0.0183535 4.55539 0.0595962C4.76349 0.0904512 4.96806 0.141696 5.16617 0.212594C5.3055 0.261578 5.42966 0.346155 5.52636 0.457962C5.62307 0.569768 5.68898 0.704931 5.71756 0.850085L6.87974 5.95001C6.91106 6.08844 6.90729 6.23253 6.86877 6.36912C6.83024 6.50572 6.75819 6.63047 6.65918 6.732C6.5489 6.851 6.54042 6.8595 5.497 7.40349C6.33258 9.24019 7.79862 10.7152 9.62824 11.5599C10.1796 10.5059 10.1881 10.4974 10.3069 10.3869C10.4082 10.2877 10.5327 10.2155 10.669 10.1769C10.8054 10.1383 10.9492 10.1346 11.0873 10.1659L16.1771 11.3304C16.3174 11.363 16.447 11.4309 16.5539 11.5275C16.6607 11.6242 16.7413 11.7465 16.7879 11.8829C16.8595 12.0847 16.9134 12.2923 16.9491 12.5034C16.9832 12.717 17.0003 12.9331 17 13.1494C16.9844 14.182 16.5617 15.1664 15.8242 15.8878C15.0868 16.6092 14.0944 17.0089 13.0639 16.9998Z" fill="#ED1C24" fillOpacity="1"/>
                            </svg>

                            <a href="tel:(747) 355 - 6046">+1 (818) 821-6033</a>
                        </li>
                        <li>
                            <svg width="22" height="22" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.33333 13.3333V2.66667H12V6H12.6667C13.2222 6 13.6944 6.19444 14.0833 6.58333C14.4722 6.97222 14.6667 7.44444 14.6667 8V13.3333H5.33333ZM3 14C3.46667 14 3.86111 13.8389 4.18333 13.5167C4.50556 13.1944 4.66667 12.8 4.66667 12.3333V7C4.66667 6.53333 4.50556 6.13889 4.18333 5.81667C3.86111 5.49444 3.46667 5.33333 3 5.33333C2.53333 5.33333 2.13889 5.49444 1.81667 5.81667C1.49444 6.13889 1.33333 6.53333 1.33333 7V12.3333C1.33333 12.8 1.49444 13.1944 1.81667 13.5167C2.13889 13.8389 2.53333 14 3 14ZM6.66667 6H10.6667V4H6.66667V6ZM10.6667 9.33333C10.8556 9.33333 11.014 9.26933 11.142 9.14133C11.27 9.01333 11.3338 8.85511 11.3333 8.66667C11.3333 8.47778 11.2693 8.31933 11.1413 8.19133C11.0133 8.06333 10.8551 7.99956 10.6667 8C10.4778 8 10.3193 8.064 10.1913 8.192C10.0633 8.32 9.99956 8.47822 10 8.66667C10 8.85556 10.064 9.014 10.192 9.142C10.32 9.27 10.4782 9.33378 10.6667 9.33333ZM12.6667 9.33333C12.8556 9.33333 13.014 9.26933 13.142 9.14133C13.27 9.01333 13.3338 8.85511 13.3333 8.66667C13.3333 8.47778 13.2693 8.31933 13.1413 8.19133C13.0133 8.06333 12.8551 7.99956 12.6667 8C12.4778 8 12.3193 8.064 12.1913 8.192C12.0633 8.32 11.9996 8.47822 12 8.66667C12 8.85556 12.064 9.014 12.192 9.142C12.32 9.27 12.4782 9.33378 12.6667 9.33333ZM10.6667 11.3333C10.8556 11.3333 11.014 11.2693 11.142 11.1413C11.27 11.0133 11.3338 10.8551 11.3333 10.6667C11.3333 10.4778 11.2693 10.3193 11.1413 10.1913C11.0133 10.0633 10.8551 9.99956 10.6667 10C10.4778 10 10.3193 10.064 10.1913 10.192C10.0633 10.32 9.99956 10.4782 10 10.6667C10 10.8556 10.064 11.014 10.192 11.142C10.32 11.27 10.4782 11.3338 10.6667 11.3333ZM12.6667 11.3333C12.8556 11.3333 13.014 11.2693 13.142 11.1413C13.27 11.0133 13.3338 10.8551 13.3333 10.6667C13.3333 10.4778 13.2693 10.3193 13.1413 10.1913C13.0133 10.0633 12.8551 9.99956 12.6667 10C12.4778 10 12.3193 10.064 12.1913 10.192C12.0633 10.32 11.9996 10.4782 12 10.6667C12 10.8556 12.064 11.014 12.192 11.142C12.32 11.27 12.4782 11.3338 12.6667 11.3333ZM6.66667 11.3333H9.33333V8H6.66667V11.3333Z" fill="#ED1C24" fillOpacity="1"/>
                            </svg>


                            <a>+1 (818) 821-6033</a>
                        </li>
                        <li>
                            <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 0V2L8 6L16 2V0H0ZM0 4V12H16V4L8 8L0 4Z" fill="#ED1C24" fillOpacity="1"/>
                            </svg>
                            <a href="mailto:info@lawestcollision.com">info@lawestcollision.com</a>
                        </li>
                        <li>
                            <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 0L0 7.5H2.5V17.5H7.5V12.5H12.5V17.5H17.5V7.425L20 7.5L10 0Z" fill="#ED1C24"
                                      fillOpacity="1"/>
                            </svg>
                            <a href={"https://goo.gl/maps/ZjcFuFxGh5gLDKv36"} target={"_blank"}>6827 Troost Ave, North Hollywood, CA 91605</a>
                        </li>
                    </ul>
                </div>
            </div>
            <NavLink
                to='/contact'
                exact
                activeClassName={"active"}
                onClick={handleNav}
            >
                <Button
                    variant="contained"
                    style={{
                        backgroundColor: "#ED1C248F",
                        fontStyle: "italic",
                        fontFamily:"hemi_head"
                    }}>
                    CONTACT US
                </Button>
            </NavLink>

        </nav>
    )
}